import { $setVar } from 'wee-store';
import { $isArray } from 'core/types';
import { $chain } from 'core/chain';
import 'es6-promise/auto';
import $ from 'wee-dom';
import $events from 'wee-events';
import '../styles/global.scss';


// Import all component scss files
require.context('../components', true, /\.scss$/);

$setVar();

$chain({
	toggleAria(item) {
		if ($isArray(item)) {
			for (let i = 0; i < item.length; i++) {
				const bool = this.attr(item[i]) === 'false' ? 'true' : 'false';

				this.attr(item[i], bool);
			}
		} else {
			const bool = this.attr(item) === 'false' ? 'true' : 'false';

			this.attr(item, bool);
		}

		return this;
	},
	changeTabindex() {
		const tabIndex = this.attr('tabindex') === '0' ? '-1' : '0';

		this.attr('tabindex', tabIndex);
		return this;
	},
});

$events.on({
	'.body': {
		keydown(e, el) {
			const $el = $(el);

			if (e.keyCode === 9 && ! $el.hasClass('-user-tabbing')) {
				$el.addClass('-user-tabbing');
			}
		},
	},
});